import { Grid } from '@mui/material'
import { t } from 'i18next'
import { AutoCompleteField } from 'src/components/shared/ui/form/fields'
import { FormField } from 'src/enums/Form'
import { useGetEntidades } from 'src/hooks/fetch/useCatalogoGeneralFilters'
import { Comunidad, Provincia, TipoRepresentacion } from 'src/interfaces/Catalog'
import { tipoRepresentacionProfesional } from '../RepresentanteProcesal/types'

type Props = {
  tipoRepresentacion?: TipoRepresentacion | null
  provincia?: Provincia | null
  comunidad?: Comunidad | null
}

export default function EntidadForm(props: Props): JSX.Element {
  const { tipoRepresentacion, provincia = null, comunidad = null } = props
  const entidadesData = useGetEntidades(FormField.ENTIDAD, provincia, comunidad) ?? []
  function enableEntidad(): boolean {
    return !comunidad && !provincia
  }
  if (tipoRepresentacion && !tipoRepresentacionProfesional(tipoRepresentacion)) {
    return (
      <>
        <Grid item xs={12} sm={6}>
          <AutoCompleteField
            id={`${FormField.ENTIDAD}`}
            label={t('form.field.entidad')}
            items={entidadesData}
            itemName="descripcion"
            loading={!enableEntidad() && entidadesData.length === 0}
            disabled={enableEntidad()}
            // (item: Entidad) => `[${item.codigo}] ${item.descripcion}`
            required
          />
        </Grid>
      </>
    )
  }
  return <></>
}
